import { Controller } from "@hotwired/stimulus"
import { startCampaignCheckout } from "../campaign_checkout.mjs"
import { t } from "../i18n.js"

export default class extends Controller {
  static targets = ["error"]

  checkout() {
    fetch("/api/stripe/checkout", {
      method: "POST",
      headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content }
    })
      .then(r => r.json())
      .then(data => {
        if (data.url) {
          window.location = data.url
        } else if (data.error?.message) {
          // e.g. 409 when the account already has a subscription to manage.
          if (this.hasErrorTarget) this.showError(data.error.message)
          else window.alert(data.error.message)
        }
      })
  }

  async checkoutCampaign(event) {
    const button = event.currentTarget
    if (button.disabled) return

    button.disabled = true
    button.setAttribute("aria-busy", "true")
    this.hideError()

    const navigated = await startCampaignCheckout({
      campaignId: button.dataset.readingCampaignId,
      csrfToken: document.querySelector('meta[name="csrf-token"]')?.content,
      navigate: url => window.location.assign(url),
      onError: message => this.showError(message)
    })

    if (!navigated) {
      button.disabled = false
      button.removeAttribute("aria-busy")
    }
  }

  hideError() {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = ""
    this.errorTarget.hidden = true
  }

  showError(message) {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = `${message} ${t("checkout_error_suffix", "If the problem continues, contact support.")}`
    this.errorTarget.hidden = false
  }

  portal() {
    fetch("/api/stripe/portal")
      .then(r => r.json())
      .then(data => { if (data.url) window.location = data.url })
  }
}
